import { API } from "config/API"

export const createProductName = async (payload) => {
  const response = await API.post("/products-names", payload)
  return response
}
